import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nss-committee',
  templateUrl: './nss-committee.component.html',
  styleUrls: ['./nss-committee.component.scss']
})
export class NssCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
